export const PACKAGE_T_KEY = 'consultation_scheduling_drawer';
